<script setup lang="ts">
  import WrapperQC from '@qicgroupdoha/qic-connect-ds/components/WrapperQC'
  import FileUploaderQC from '@qicgroupdoha/qic-connect-ds/components/FileUploaderQC'
  import BlockTitle from './BlockTitle/BlockTitle.vue'
  import AccordionButton from './AccordionButton/AccordionButton.vue'
  import { useI18n } from 'vue-i18n'

  interface Props {
    uploadResult: 'error' | 'success' | undefined
    errorMessage: string
    uploadResultErrors?: string[]
    isOcrManualMode: boolean
  }

  const { locale } = useI18n()
  defineProps<Props>()
  const emit = defineEmits<{
    (e: 'update:uploadResult', value: 'error' | 'success' | undefined): void
    (e: 'file-selected', file: File): void
    (e: 'cancel'): void
    (e: 'error:file-size'): void
    (e: 'click'): void
    (e: 'toggle-manual-mode'): void
    (e: 'before-cancel'): Promise<boolean> | boolean
  }>()

  const onBeforeCancel = (): Promise<boolean> | boolean => {
    return (emit as any)('before-cancel')
  }
</script>

<template>
  <WrapperQC
    v-if="!isOcrManualMode"
    direction="column"
    gap="var(--spacing-7)"
    class="visitor-form__uploader"
  >
    <BlockTitle
      icon="passport"
      :text="$t('visitors.fill_visitors_info.upload_passport.heading.text')"
    />
    <KeepAlive>
      <FileUploaderQC
        :upload-result="uploadResult"
        :locale="locale"
        size="medium"
        auto-progress
        :error="uploadResultErrors?.[0] ?? errorMessage"
        :max-file-size="20"
        :i18n="{
          hint: {
            en: $t('visitors.fill_visitors_info.file_recognition.type_size_text'),
            ar: $t('visitors.fill_visitors_info.file_recognition.type_size_text'),
          },
        }"
        :before-cancel="onBeforeCancel"
        data-test="file-uploader"
        @update:upload-result="emit('update:uploadResult', $event)"
        @file-selected="emit('file-selected', $event)"
        @cancel="emit('cancel')"
        @error:file-size="emit('error:file-size')"
        @click="emit('click')"
      />
    </KeepAlive>
  </WrapperQC>

  <WrapperQC
    direction="column"
    gap="var(--spacing-7)"
    class="visitor-form__uploader-divider"
  >
    <AccordionButton v-if="isOcrManualMode" icon="passport" @click="emit('toggle-manual-mode')">
      {{ $t('visitors.fill_visitors_info.change_mode_ocr.button') }}
    </AccordionButton>

    <div class="visitor-form__divider text-medium">
      {{ $t('visitors.fill_visitors_info.or.text') }}
    </div>
    <AccordionButton v-if="!isOcrManualMode" icon="hand" @click="emit('toggle-manual-mode')">
      {{ $t('visitors.fill_visitors_info.change_mode_manually.button') }}
    </AccordionButton>
  </WrapperQC>
</template>

<style lang="scss" scoped>
  .visitor-form__divider {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--spacing-8);
    position: relative;
    &::before,
    &::after {
      content: '';
      width: 100%;
      height: 1px;
      background-color: var(--colorBrdrSrfPrimary);
    }
  }
</style>
